module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-wrapper"
  }, [_c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("About")]), _vm._v(" "), _c('Carousel', {
    attrs: {
      "items": _vm.result
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d0dbb74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 276
// module chunks = 0